import { apiPost } from "./api";

export default class ServicioCitas {
  static crearCita(cita) {
    return apiPost("/citas/Crear", cita);
  }

  static getCitasFecha(fechaInicial, fechaFinal, enfermeraID) {
    const data = {
      FechaInicial: fechaInicial,
      FechaFinal: fechaFinal,
      Enfermera_UsuarioID: enfermeraID,
    };
    return apiPost("/citas/consulta/Fecha", data);
  }
  static getCitasFolio(folio) {
    const data = {
      Folio: folio,
    };
    return apiPost("/citas/consulta/Folio", data);
  }
  static getCitasNombre(nombre) {
    const data = {
      NombrePaciente: nombre,
    };
    return apiPost("/citas/consulta/Nombre", data);
  }
  static cancelarCita(folioPaciente) {
    const data = {
      FolioPaciente: folioPaciente,
    };
    return apiPost("/citas/cancelar/FolioPaciente", data);
  }
  static getCita(citaID) {
    return apiPost("/citas/info/Cita", { CitaID: citaID });
  }
  static actualizarCita(cita) {
    return apiPost("/citas/Actualizar", cita);
  }
  static getHorasCitas(dia, enfermeraID = 0) {
    const data = {
      FechaInicial: `${dia}T00:00:00`,
      FechaFinal: `${dia}T23:59:59`,
      Enfermera_UsuarioID: enfermeraID,
    };
    return apiPost("/citas/consulta/Horas", data);
  }
  static cancelarCitas(citas) {
    const data = {
      FoliosPacientes: citas,
    };
    return apiPost("/citas/cancelar/FoliosPacientes", data);
  }
}
